import { render, staticRenderFns } from "./VInputV3.vue?vue&type=template&id=3a97f89a&scoped=true&"
import script from "./VInputV3.vue?vue&type=script&lang=js&"
export * from "./VInputV3.vue?vue&type=script&lang=js&"
import style0 from "./VInputV3.vue?vue&type=style&index=0&id=3a97f89a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a97f89a",
  null
  
)

export default component.exports